import { isValid, parse, parseISO } from 'date-fns';

export const EMPTY_INSURANCE_FIELDS = {
  usingInsurance: null,
  insuranceCarrier: '',
  memberID: '',
  groupNumber: '',
};

export type PatientAgeBracket = 'Adult' | 'Child' | 'Infant';

const DATE_ONLY_DOB_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const DATE_ONLY_DOB_FORMAT = 'yyyy-MM-dd';

const parseDobToDate = (dob: string): Date | undefined => {
  if (DATE_ONLY_DOB_REGEX.test(dob)) {
    const parsedDate = parse(dob, DATE_ONLY_DOB_FORMAT, new Date());
    return isValid(parsedDate) ? parsedDate : undefined;
  }

  const parsedDate = parseISO(dob);
  if (!isValid(parsedDate)) return undefined;

  return parsedDate;
};

export const deriveAgeBracket = (
  dob?: string | null,
): PatientAgeBracket | undefined => {
  if (!dob) return undefined;
  const birth = parseDobToDate(dob);
  if (!birth) return undefined;

  const now = new Date();
  let years = now.getFullYear() - birth.getFullYear();
  const monthDiff = now.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) {
    years -= 1;
  }

  if (years < 0) return undefined;
  if (years < 1) return 'Infant';
  if (years < 18) return 'Child';
  return 'Adult';
};
